
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"27","height":"30"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","d":"M16.332.437l-5.907 3.357L0-.002v25.679l10.648 3.894 5.926-3.368L27 29.999V4.32L16.332.437zm-5.136 4.448l4.608-2.619v22.846l-4.608 2.619V4.885zm-9.879-2.99l8.562 3.117v22.86L1.317 24.74V1.895zm24.366 26.207l-8.562-3.117V2.141l8.562 3.117v22.844z"}})])
          )
        }
      }
    